if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab' || !this.hasAttribute('open')) return;
          const elements = getFocusableElements(this).filter((element) =>
            element.getClientRects().length && getComputedStyle(element).visibility === 'visible'
          );
          const first = elements[0] || this.querySelector('[role="dialog"]');
          const last = elements[elements.length - 1] || first;
          if (event.shiftKey && (event.target === first || event.target === this.querySelector('[role="dialog"]'))) {
            event.preventDefault();
            event.stopPropagation();
            last.focus();
          } else if (!event.shiftKey && event.target === last) {
            event.preventDefault();
            event.stopPropagation();
            first.focus();
          }
        });
        this.containFocus = (event) => {
          if (this.hasAttribute('open') && !this.contains(event.target)) {
            this.querySelector('[id^="ModalClose-"]').focus();
          }
        };
      }

      hide() {
        document.removeEventListener('focusin', this.containFocus);
        super.hide();
      }

      show(opener) {
        this.openedBy = opener;
        this.hydrateImage(this.querySelector(`[data-media-id="${opener.getAttribute('data-media-id')}"]`));
        super.show(opener);
        this.observeDeferredImages();
        this.showActiveMedia();
        document.addEventListener('focusin', this.containFocus);
      }

      hydrateImage(element) {
        const image = element?.matches('img[data-src]') ? element : element?.querySelector('img[data-src]');
        if (!image) return;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        delete image.dataset.srcset;
        delete image.dataset.src;
        this.deferredImageObserver?.unobserve(image);
      }

      observeDeferredImages() {
        if (!this.deferredImageObserver) {
          this.deferredImageObserver = new IntersectionObserver(
            (entries) => entries.forEach((entry) => entry.isIntersecting && this.hydrateImage(entry.target)),
            { root: this.querySelector('[role="document"]'), rootMargin: '100% 0px' }
          );
        }
        this.querySelectorAll('img[data-src]').forEach((image) => this.deferredImageObserver.observe(image));
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
